// Your deployed contract address from Phase 4
export const CONTRACT_ADDRESS = "0x232c1d11FD0d33af68E5Bccc6De5413Fa27D5F9e";

// Network config
export const NETWORK = {
    chainId:     "0xaa36a7",  // Sepolia chain ID in hex
    chainName:   "Sepolia test network",
    rpcUrls:     ["https://sepolia.infura.io/v3/"],
    blockExplorerUrls: ["https://sepolia.etherscan.io"]
};

// Status labels matching contract enum order
export const STATUS_LABELS = {
    0: { label: "Created",      color: "#3b82f6", icon: "🏭" },
    1: { label: "In Warehouse", color: "#8b5cf6", icon: "🏪" },
    2: { label: "In Transit",   color: "#f59e0b", icon: "🚚" },
    3: { label: "At Retailer",  color: "#10b981", icon: "🏬" },
    4: { label: "Delivered",    color: "#22c55e", icon: "✅" },
    5: { label: "Recalled",     color: "#ef4444", icon: "⚠️" },
};

// Role names for display
export const ROLES = {
    MANUFACTURER: "MANUFACTURER_ROLE",
    WAREHOUSE:    "WAREHOUSE_ROLE",
    DISTRIBUTOR:  "DISTRIBUTOR_ROLE",
    RETAILER:     "RETAILER_ROLE",
};